import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional } from 'class-validator';


export class StockItemCategoryDTO {
  @ApiProperty()
  @IsNotEmpty()
  id: number;


  @ApiProperty()
  @IsNotEmpty()

  category: string;
  @ApiProperty()
  @IsNotEmpty()

  type: string;

  
  @ApiProperty()
  @IsNotEmpty()
  createdUser: string ;


  @ApiProperty()
  @IsOptional()
  createdAt: Date;


  @ApiProperty()
  updatedAt: Date;

  @ApiProperty()
  @IsNotEmpty()
  updatedUser: string ;
}
